import { IConfig } from '@cian/config/shared';
import { TPublicWebV1SearchOffersForNewbuildingPromosResponse_1 } from '../repositories/search-offers/web/v1/search-offers-for-newbuilding-promos';
import { IPromoOffersState } from '../types/promoOffersSelection';

interface IPreparePromoOffersSelection {
  config: IConfig;
  promoOffersResponse: TPublicWebV1SearchOffersForNewbuildingPromosResponse_1 | null;
}

export const mapPromoOffersSelection = ({
  config,
  promoOffersResponse,
}: IPreparePromoOffersSelection): IPromoOffersState => {
  const isEnabled = Boolean(config.get<boolean>('Newbuilding.PromoOffersSelection.Enabled'));

  if (!promoOffersResponse || !promoOffersResponse.promoOffers) {
    return {
      isEnabled: false,
      listingUrl: '',
      offersIds: [],
      offers: [],
    };
  }

  const { listingUrl, offers } = promoOffersResponse.promoOffers;

  return {
    isEnabled,
    listingUrl,
    offersIds: offers.map(offer => offer.offerId),
    offers,
  };
};
